import { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { supabase } from './supabase';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CreateExperiment from './pages/CreateExperiment';
import ViewExperiment from './pages/ViewExperiment';
import Profile from './pages/Profile';
import Instructions from './pages/Instructions';
import Landing from './pages/Landing';
import Header from './components/Header'; // Import the Header component

function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      setLoading(false); // Set loading to false after session is determined
    });

    // Initial session check
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return <div>Loading app...</div>; // Or a loading spinner
  }

  return (
    <div className="App">
      {session && <Header />} {/* Render Header only if session exists */}
      <div className="main-content">
        <Routes>
          {/* Login route - redirect to dashboard if already authenticated */}
          <Route 
            path="/login" 
            element={session ? <Navigate to="/dashboard" replace /> : <Login />} 
          />
          
          {/* Public Landing Page */}
          <Route
            path="/"
            element={<Landing />}
          />
          
          {/* Protected Routes - redirect to login if not authenticated */}
          <Route
            path="/dashboard"
            element={session ? <Dashboard /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/create"
            element={session ? <CreateExperiment /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/experiment/:id"
            element={session ? <ViewExperiment /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/profile"
            element={session ? <Profile /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/instructions"
            element={session ? <Instructions /> : <Navigate to="/login" replace />}
          />
          
          {/* Catch-all for unknown routes */}
          <Route path="*" element={session ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
